import { Components } from '@mui/material';

const muiButtonGroupStyles: Components = {
  MuiButtonGroup: {
    styleOverrides: {
      root: {
        '&.custom-button-group-class': {
          '& .MuiButton-root': {
            borderColor: 'var(--gray-6)',
            backgroundColor: 'var(--gray-11)',
            display: 'flex',
            justifyContent: 'flex-start',
            paddingLeft: '31px',
            '@media (max-width:1715px)': {
              paddingRight: '31px'
            }
          },
          '& .MuiButton-root:last-of-type': {
            borderRadius: '0 50px 50px 0',
            backgroundColor: 'var(--primary)',
            color: 'var(--white)'
          },
          '& .MuiButton-root:first-of-type': {
            borderRadius: '50px 0 0 50px'
          },
          '& .MuiButton-root:nth-of-type(3)': {
            width: '100%',
            maxWidth: '500px'
          },
          '& .MuiButton-root:nth-of-type(4)': {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '260px'
          }
        }
      }
    }
  }
};

export default muiButtonGroupStyles;
